import { logger as E } from "../../shared-lib/index.js";
import { BANNERS_DISABLED_MESSAGE as v } from "../common/constants.js";
import r from "../managers/braze-instance.js";
import i from "./banner-provider-factory.js";
export function getBannerIfNotExpired(n, r) {
  var e = n[r];
  if (!e) return null;
  var t = e.zt,
    o = new Date().valueOf();
  return -1 !== t && 1e3 * t < o ? (E.info("Banner with ID: ".concat(e.id, " and placement ID: ").concat(r, " has expired.")), null) : e;
}
export function getBanner(n) {
  var e;
  if (!r.rr()) return;
  !1 === (null === (e = r.l()) || void 0 === e ? void 0 : e.Dt()) && E.error(v);
  var t = i.o();
  if (!t.k()) return null;
  return getBannerIfNotExpired(t.ht(), n);
}